import { AxiosBaseApi } from '@config/axios.config'
import { ENDPOINTS } from '@constants'
import { AxiosResponse } from 'axios'

export type MatchScoreWeekMeta = {
  id: number
  identifier: string
  week: number
  year: number
  stamp: string
}

export type MatchScoreResponse = {
  data: any[]
  meta: { week: MatchScoreWeekMeta }
}

export class WeeksApi extends AxiosBaseApi {
  get_match_score = (id: number | string): Promise<MatchScoreResponse> =>
    this.api
      .get<AxiosResponse<MatchScoreResponse>>(ENDPOINTS.WEEKS.MATCH_SCORE(id))
      .then(response => response.data as unknown as MatchScoreResponse)

  get_specifications = (
    id: number | string
  ): Promise<{ data: any[]; meta: { week: MatchScoreWeekMeta } }> =>
    this.api
      .get<AxiosResponse<any>>(ENDPOINTS.WEEKS.SPECIFICATIONS(id))
      .then(response => response.data as any)
}
